import { menuItems } from '@/cms/header';

export const footer = {
  links: menuItems,
};
